import prop from 'ramda/src/prop'
import { getCookie } from 'root/src/client/v2/browser/helpers/cookies'
import authenticationSelector from 'root/src/client/logic/auth/selectors/authenticationSelector'

export default state => getCookie('userId') || prop('userId', authenticationSelector(state))
